import React from "react";
import { Link } from "react-router-dom";

import "./../../Styles/BackArrow.css";

const BackArrow = ({ link, top, left }) => {
    return (
        <Link to={link} className="BackArrow_wrapper" style={{ top, left }}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="10"
                viewBox="0 0 15 10"
                fill="none"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.0979 5.05276C14.0979 4.91928 14.0449 4.79127 13.9505 4.69688C13.8561 4.6025 13.7281 4.54947 13.5946 4.54947H1.72403L4.89173 1.38278C4.98623 1.28827 5.03933 1.1601 5.03933 1.02645C5.03933 0.892798 4.98623 0.764622 4.89173 0.670118C4.79722 0.575614 4.66905 0.522522 4.5354 0.522522C4.40175 0.522522 4.27358 0.575614 4.17907 0.670118L0.152756 4.69643C0.105886 4.74319 0.0687008 4.79872 0.0433283 4.85987C0.0179558 4.92101 0.00489616 4.98656 0.00489616 5.05276C0.00489616 5.11896 0.0179558 5.18451 0.0433283 5.24566C0.0687008 5.3068 0.105886 5.36234 0.152756 5.40909L4.17907 9.43541C4.27358 9.52991 4.40175 9.583 4.5354 9.583C4.66905 9.583 4.79722 9.52991 4.89173 9.43541C4.98623 9.3409 5.03933 9.21273 5.03933 9.07908C5.03933 8.94543 4.98623 8.81726 4.89173 8.72275L1.72403 5.55605H13.5946C13.7281 5.55605 13.8561 5.50303 13.9505 5.40864C14.0449 5.31426 14.0979 5.18624 14.0979 5.05276Z"
                    fill="#fff"
                    stroke="#fff"
                />
            </svg>
        </Link>
    );
};

BackArrow.defaultProps = {
    link: "/",
    top: "-20px",
    left: "5%",
};

export default BackArrow;
